import { Helmet } from 'react-helmet'
import ClearFiltersButton from 'components/common/clearFiltersButton'
import {
  PriceLabelSyncHistoryExportButton,
  PriceLabelSyncHistoryFilterForm,
  PriceLabelSyncHistoryTable,
} from 'components/priceLabelSyncHistory'
import { FILTER_FIELD_PRICE_LABEL_SYNC_HISTORY } from 'components/priceLabelSyncHistory/utils'

const PriceLabelSyncHistoryPage = () => {
  return (
    <>
      <Helmet>
        <title>GAG Aggregator | Price Label Sync History</title>
      </Helmet>

      <div className="flex items-center justify-between gap-2">
        <div className="title">Price Label Sync History</div>

        <div className="flex flex-wrap items-center justify-end gap-1">
          <ClearFiltersButton
            filterKey={FILTER_FIELD_PRICE_LABEL_SYNC_HISTORY}
          />

          <PriceLabelSyncHistoryExportButton />
        </div>
      </div>

      <PriceLabelSyncHistoryFilterForm />
      <PriceLabelSyncHistoryTable />
    </>
  )
}

export default PriceLabelSyncHistoryPage
